<div *ngIf="purchase.id" [@openClose]="isOpen ? 'open' : 'closed'" class="container-btn-payment">
    <span *ngIf="!isOpen" (click)="openClose()" class="text-btn">Pagar</span>
    <span *ngIf="isOpen" (click)="openClose()" class="icon-close">x</span>

    <div *ngIf="isOpen" class="content-payment">
        <br><br><br><br><br>
        <span class="title-info">Productos </span>
        <div class="container-list-products">
            <div *ngFor="let product of purchase.products" class="container-product-info">
                <div [ngStyle]="{'background': 'no-repeat center/cover url('+product.image+')'}" class="container-product-image">
                </div>
                <div class="container-product-info">
                    <span class="name-product"> {{ product.description2 }} </span>
                    <span class="price-product"> {{ product.price | currency:'USD':symbol:'1.0-0' }} </span>
                </div>
            </div>
        </div>
    
        <span class="title-info">Forma de pago </span>
        <div class="container-list-payment-methods">
            <a
                *ngFor="let payment of purchase.paymentMethods"
                class="payment-method"
                [ngClass]="{'selected': payment.selected}"
                (click)="selectPaymentMethod(payment)"
            > {{ payment.description }} </a>
        </div>
        <br>
        <span class="title-info">Propina 10% </span>
        <div (click)="updateTip()" class="container-tip" [ngClass]="{'checked': this.purchase.tipPrice != 0}" >
            <span class="tip"></span>
        </div>
        <span class="title-info">Total </span>
        <span class="total"> {{ purchase.total | currency:'USD':symbol:'1.0-0' }} </span>

        <a *ngIf="showBtnPayment" (click)="getUrlPayment()" class="btn-payment"> {{ this.purchase.paymentStatus == 'Pagado' ? 'Facturado' : 'Pagar' }} </a>
        <a *ngIf="!showBtnPayment" (click)="payInStore()" class="btn-payment"> Pagar al mesero </a>

    </div>

    <div [@popUp]="showPopUp ? 'showPopUp' : 'hiddePopUp'" class="container-popup">
        <p class="message">
            En breves minutos el mesero te atenderá.
        </p>
    </div>

</div>